import { NominatedCard } from "@/web/routes/browse/-components/cards/NominatedCard";
import { OfferingCard } from "@/web/routes/browse/-components/cards/OfferingCard";
import { RoadshowCard } from "@/web/routes/browse/-components/cards/RoadshowCard";
import { SharableBusinessCardCard } from "@/web/routes/browse/-components/cards/SharableBusinessCardCard";
import type { BrowseResult } from "@/web/routes/browse/-components/types";

export function BrowseCard({ result }: { result: BrowseResult }) {
  if (result.type === "claimedNominatedBusiness" || result.type === "unclaimedNominatedBusiness") {
    return <NominatedCard browseResult={result} />;
  }

  if (result.type === "offering") {
    return <OfferingCard browseResult={result} />;
  }

  if (result.type === "roadshow") {
    return <RoadshowCard browseResult={result} />;
  }

  if (result.type === "sharableBusinessCard") {
    return <SharableBusinessCardCard browseResult={result} />;
  }

  return null;
}
